module.exports = __webpack_public_path__ + "static/media/rocket.b85ec149.jpg";